import { Model } from 'backbone';

class SettingsModel extends Model { 
 
    initialize() {  

        this.on('change', function(){
            window.localStorage.setItem('pfUserSettings', JSON.stringify(this));
        });
    } 

    defaults() {
        const def = {};
        def._edAl = '';
        def._edBrTbC = '';
        def._edDs = '';
        def._edNo = '';
        def._edNoHtml = '';
        def._edOb = '';
        def._edPaDlWa = '';
        def._edObDlWa = '';
        def._edPbCaC = '';
        def._edPbW = '';
        def._edScDlWa = '';
        def._edScReWa = '';
        def._edShGrid = '';
        def._edShHC = '';
        def._edShNV = '';
        def._edShSM = '';
        def._edShWfM = '';
        def._edSt = '';
        def._edTbLaTbC = '';
        def._edTbScTbC = '';
        def._edTbW = '';
        def._edTbWfTbC = '';
        def._maBrMd = '';
        def._maCoFfDg = '';
        def._maDaHiDg = '';
        def._maFD = '';
        def._maInWs1 = '';
        def._maInWs2 = '';
        def._maInWs3 = '';
        def._maInWs4 = '';
        def._maMxIn = '';
        def._maNoWs1 = '';
        def._maNoWs2 = '';
        def._maNoWs3 = '';
        def._maNoWs4 = '';
        def._maShGS = '';
        def._maShHo = '';
        def._maShQH = '';
        def._maShMI = '';
        def._maStEd = '';
        def._maSz = '';
        def._maTrW = '';
        def._maUsWs = '';
        def._commonGroup = '';
        def._behCommonGroup = '';
        def._repCommonGroup = '';
        def._repBehCommonGroup = '';
        def._moShHC = 'false'; // false to indicate that user haven't seen the help center
        def._moShAS = 'true'; // value of checkbox "show at startup" to show startup wizzard 

        // PF-5694
        def._moHCVideo = 'false'; // false to indicate that user haven't seen the mobile video

        // PF-5273
        def._showHiddenNotifications_A = 'true'; // Attention needed
        def._showHiddenNotifications_NA = 'true'; // No attention needed

        //PF-10250
        def._tScratch = JSON.stringify({show: 'true', complete: 'false'}); 
        def._tWalk = JSON.stringify({show: 'true', complete: 'false'}); 
        return def;
    }

}

export default SettingsModel;